import React from 'react';
import { PhoneOutgoing } from 'lucide-react';
import { useContact } from '../../context/ContactContext';
import { displaySummary } from '../../lib/summary';

// #20 (2026-09-23): a VOICE leg the agent dialled FOR a scheduled callback.
// Storm's live finding: the task view showed the escalation reason, AI
// handover and history, then the outbound call took the centre with "No AI
// summary available" and no link back. This card says what the call is for,
// from the callback the dial was made for (lib/callbackOrigin.js). Same
// markup family as CallbackTaskCard so it inherits its styling.
export default function CallbackOriginCard() {
  const { display } = useContact();
  const o = display?.callbackOrigin;
  if (!display || !o || display.meta?.channel === 'TASK') return null;
  const summary = displaySummary(o.aiSummary);
  return (
    <div className="task-card task-card-origin">
      <div className="task-card-head">
        <span className="task-card-icon"><PhoneOutgoing size={13} /></span>
        <span className="task-card-title">Calling back for a scheduled callback</span>
        {o.window && <span className="task-card-window">{o.window}</span>}
      </div>
      <p className="task-card-copy">
        This call is the callback{o.callerNumber ? <> to <strong>{o.callerNumber}</strong></> : null}.
        {o.reason ? <> Why it was booked: <strong>{o.reason}</strong>.</> : null}
        {summary ? <> What the AI recorded on the original call: {summary}</> : null}
      </p>
      <div className="task-card-ids">
        <span title={o.callbackId}>callback {String(o.callbackId).slice(0, 8)}…</span>
        {o.originalContactId && <span title={o.originalContactId}>booked on contact {String(o.originalContactId).slice(0, 8)}…</span>}
        {o.source === 'dial-context' && <span title="Only this console knows the link until the contact attributes carry it">link held in this console</span>}
      </div>
    </div>
  );
}
